export const LOADING_FACTURAS = "LOADING_FACTURAS";
export const GET_FACTURAS_SUCCESS = "GET_FACTURAS_SUCCESS";
export const GET_FACTURAS_FAILURE = "GET_FACTURAS_FAILURE";
export const SET_FACTURAS_PAGE = "SET_FACTURAS_PAGE";
export const RESET_FACTURAS = "RESET_FACTURAS";
